import JwtService from './jwtService';
import JwtServiceLocal from './jwtServiceLocal';

const isLocalMode = process.env.REACT_APP_LOCAL_AUTH === 'true';

export default isLocalMode ? JwtServiceLocal : JwtService;
